import { Pipe, PipeTransform } from '@angular/core';
import numeral from 'numeral';

@Pipe({
  name: 'numberFormat',
  standalone: false,
})
export class NumberFormatPipe implements PipeTransform {
  /**
   * @see http://numeraljs.com/#format
   */
  transform(value: number, format = '0,0'): string {
    return numeral(value).format(format);
  }
}
